// extracted by mini-css-extract-plugin
module.exports = {"boxContain":"styles_boxContain__1SR2i","colorContainer":"styles_colorContainer__339Gw"};